import FetchService from "./Shared/FetchService";
import CourseSectionMeetingService from "../Domain/CourseSectionMeeting/CourseSectionMeeting.service";
import TranscriptCourseDomainService from "../Domain/TranscriptCourse/TranscriptCourseDomainService";
/**
 * This service doesn't directly correspond to a controller.  Partly for convenience, and partly to avoid
 * having a massive AdvisorService, this combines a few endpoints that have to do with the roster page,
 * or the aviso attendance system.
 */
export default class AttendanceService {
    static getRosterWithAttendance(
    // @ts-expect-error - TS2741 - Property 'courseSectionId' is missing in type '{}' but required in type '{ courseSectionId: string; courseSectionScheduleElementId?: number | undefined; meetingStartDate?: Date | undefined; transcriptCourseStatusIds?: string[] | null | undefined; termAttendanceStatusIds?: number[] | ... 1 more ... | undefined; }'.
    request = {}) {
        return FetchService.getSingleResponse("/aviso/advisor/getRosterWithAttendance", {
            courseSectionId: request.courseSectionId,
            meetingStartDate: request.meetingStartDate,
            courseSectionScheduleElementId: request.courseSectionScheduleElementId,
            transcriptCourseStatusIds: request.transcriptCourseStatusIds,
            termAttendanceStatusIds: request.termAttendanceStatusIds,
        }).then((transcripts) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        transcripts.map(TranscriptCourseDomainService.fromJson));
    }
    static getMissingAttendance(courseSectionId) {
        return FetchService.getSingleResponse("/aviso/attendance/getMissingAttendance", { courseSectionId }).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            meetingsMissingAttendance: resp.meetingsMissingAttendance.map(CourseSectionMeetingService.fromJSON) })));
    }
    static setAttendanceStatus(transcriptCourseId, meetingId, attendanceStatusId) {
        return FetchService.postSingleResponse("/aviso/attendance/setAttendanceStatus", Object.assign(Object.assign({}, meetingId), { transcriptCourseId, attendanceStatusId }));
    }
    static deleteAttendanceStatus(transcriptCourseId, meetingId) {
        return FetchService.postSingleResponse("/aviso/attendance/deleteAttendanceStatus", Object.assign(Object.assign({}, meetingId), { transcriptCourseId }));
    }
    static saveCommentOnTranscriptCourseAttendance(transcriptCourseAttendanceId, comment) {
        return FetchService.postSingleResponse("/aviso/attendance/saveCommentOnTranscriptCourseAttendance", { transcriptCourseAttendanceId, comment });
    }
    static markManuallyExcused(transcriptCourseId, meetingId, isExcused) {
        return FetchService.postSingleResponse("/aviso/attendance/markManuallyExcused", Object.assign(Object.assign({}, meetingId), { transcriptCourseId, isExcused }));
    }
    /**
     * Cancels a meeting
     *
     * @param {CourseSectionMeetingIdentifiers} meetingId - id of the meeting
     * @returns {Promise<null>} - resolution of promise indicates the operation was successful
     */
    static cancelMeeting(meetingId) {
        return FetchService.postSingleResponse("/aviso/courseSection/addExcludedDate", {
            courseSectionScheduleElementId: meetingId.sourceScheduleElementId,
            meetingDate: meetingId.meetingStartDate,
        });
    }
    /**
     * Un-cancels a meeting
     *
     * @param {CourseSectionMeetingIdentifiers} meetingId - id of the meeting
     * @returns {Promise<null>} - resolution of promise indicates the operation was successful
     */
    static unCancelMeeting(meetingId) {
        return FetchService.deleteSingleResponse("/aviso/courseSection/deleteExcludedDate", {
            courseSectionScheduleElementId: meetingId.sourceScheduleElementId,
            meetingDate: meetingId.meetingStartDate,
        });
    }
    static getTranscriptCourse(transcriptCourseId, meetingId) {
        return FetchService.getSingleResponse("/aviso/attendance/getTranscriptCourse", {
            transcriptCourseId,
            meetingStartDate: meetingId.meetingStartDate,
            sourceScheduleElementId: meetingId.sourceScheduleElementId,
        }).then(TranscriptCourseDomainService.fromJson);
    }
    static hasPermissionToViewAttendanceDetails() {
        return FetchService.getSingleResponse("/aviso/attendance/hasPermissionToViewAttendanceDetails");
    }
    static getTranscriptCourseAttendance(transcriptCourseId) {
        return FetchService.getSingleResponse("/aviso/attendance/getTranscriptCourseAttendance", { transcriptCourseId }).then((resp) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'item' implicitly has an 'any' type.
        resp.map((item) => (Object.assign(Object.assign({}, item), { courseSectionMeeting: CourseSectionMeetingService.fromJSON(item.courseSectionMeeting) }))));
    }
    static getMyTranscriptCourseAttendance(transcriptCourseId) {
        return FetchService.getSingleResponse("/aviso/attendance/getTranscriptCourseAttendanceForCurrentUser", { transcriptCourseId });
    }
    static canIManageExcusedAbsences() {
        return FetchService.getSingleResponse("/aviso/attendance/canIManageExcusedAbsences");
    }
    static openMobileAttendance(courseSectionId, meetingId, secondsToKeepOpen, enforceLocationForAttendance) {
        return FetchService.postSingleResponse("/aviso/attendance/openMobileAttendance", {
            courseSectionId,
            meetingStartDate: meetingId.meetingStartDate,
            sourceScheduleElementId: meetingId.sourceScheduleElementId,
            secondsToKeepOpen,
            enforceLocationForAttendance,
        });
    }
    static closeMobileAttendance(courseSectionId, meetingId) {
        return FetchService.postSingleResponse("/aviso/attendance/closeMobileAttendance", {
            courseSectionId,
            meetingStartDate: meetingId.meetingStartDate,
            sourceScheduleElementId: meetingId.sourceScheduleElementId,
        });
    }
    static isMobileAttendanceOpen(courseSectionId) {
        return FetchService.getSingleResponse("/aviso/attendance/mobileAttendanceOpen", { courseSectionId });
    }
    static getMobileAttendanceCodeForMeeting(courseSectionId, meetingId) {
        return FetchService.postSingleResponse("/aviso/attendance/getMobileAttendanceCodeForMeeting", {
            courseSectionId,
            meetingStartDate: meetingId.meetingStartDate,
            sourceScheduleElementId: meetingId.sourceScheduleElementId,
        });
    }
    static getAttendanceEnforcementDistance() {
        return FetchService.getSingleResponse("/aviso/attendance/getAttendanceEnforcementDistance");
    }
    static getBuildingForMeeting(courseSectionId, meetingId) {
        return FetchService.getSingleResponse("/aviso/attendance/getBuildingForMeeting", {
            courseSectionId,
            meetingStartDate: meetingId.meetingStartDate,
            sourceScheduleElementId: meetingId.sourceScheduleElementId,
        });
    }
}
